// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1Yv52","left":"StickyBox_left__3j-FM","right":"StickyBox_right__13Vb8"};